import { AnyClass, nopString } from '../common/mod.js';
import { EventEmitterMixin } from '../event/mod.js';
import { DateTime, Duration, createDateTime } from './date_time.js';
export class DefaultClock extends EventEmitterMixin(AnyClass) {
    externalDateFetcher;
    syncInterval;
    offset = 0;
    resolution;
    offTick = 0;
    offSync = 0;
    now = createDateTime();
    constructor(resolution, externalDateFetcher, syncInterval) {
        super();
        this.externalDateFetcher = externalDateFetcher;
        this.syncInterval = syncInterval;
        if (resolution && !resolution.isValid) {
            throw new Error('Invalid clock resolution');
        }
        this.resolution = resolution ?? Duration.fromISO('PT1S');
        if (this.externalDateFetcher) {
            this.syncInterval ??= Duration.fromISO('PT2H');
        }
    }
    async externalSync() {
        if (!this.externalDateFetcher) {
            throw new Error('DefaultClock.externalDateFetcher() handler not defined');
        }
        const offsets = [];
        for (let i = 0; i < 5; ++i) {
            const t0 = Date.now();
            const external = await this.externalDateFetcher();
            const t1 = Date.now();
            const rtt = t1 - t0;
            const offset = external.toMillis() + rtt / 2;
            offsets.push(offset - t1);
        }
        if (offsets.length === 0) {
            throw new Error('Could not get external time from any attempts');
        }
        this.offset = offsets.reduce((a, b) => a + b, 0) / offsets.length;
        return this;
    }
    async start() {
        if (this.offTick) {
            return this;
        }
        if (this.externalDateFetcher) {
            await this.externalSync();
            if (this.syncInterval) {
                this.offSync = setInterval(() => {
                    void this.externalSync();
                }, this.syncInterval.as('milliseconds'));
            }
        }
        this.offTick = setInterval(() => {
            const next = this.createDateTime();
            this.emit('tick', next, this.now);
            this.now = next;
        }, this.resolution.as('milliseconds'));
        return this;
    }
    stop() {
        clearInterval(this.offTick);
        this.offTick = 0;
        clearInterval(this.offSync);
        this.offSync = 0;
        return this;
    }
    toIso() {
        return this.now.toISO() ?? nopString;
    }
    toFormat(pattern) {
        return this.now.toFormat(pattern);
    }
    toLocaleString(options) {
        return this.now.toLocaleString(options);
    }
    createDateTime() {
        return this.offset ? DateTime.fromMillis(Date.now() + this.offset) : createDateTime();
    }
}
//# sourceMappingURL=_default_clock.js.map